import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { DOCUMENT_ROUTES } from '../constants/routes.constants'

import { appLayoutRoute } from '@/core/router/layouts'

const documentsListRoute = createRoute({
  path: DOCUMENT_ROUTES.LIST,
  getParentRoute: () => appLayoutRoute,
  component: lazyRouteComponent(() =>
    import('../pages').then(m => ({ default: m.DocumentsListPage }))
  ),
})

const documentsRoutes = [documentsListRoute]

export default documentsRoutes
